import { render } from "./contact-page.vue?vue&type=template&id=155c5719"
import script from "./contact-page.vue?vue&type=script&lang=js"
export * from "./contact-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__